import { datepickerToDate } from '../../../libs/dates';
import ApplicationController from './application_controller';

/**
 * TODO: Todo el formulario de justificación anticipada debería de ser un
 * componente Vue y no tendríamos que tener brujerías por ahí
 */
/* global $ */
export default class extends ApplicationController {
  connect() {
    $(this.element).on('change', '#justificacion_usuario_id', () => {
      this._refrescarHorarios();
    });

    this._conectarFechas();
  }

  _refrescarHorarios() {
    const inicio = $(this.element).find('[name="justificacion[inicio]"]').val();
    const fin = $(this.element).find('[name="justificacion[fin]"]').val();

    const $usuario = $('#justificacion_usuario_id option:selected');
    $.post('/justificaciones_anticipadas/horarios', {
      inicio,
      fin,
      usuario_id: $usuario.val(),
      grupo_id: $usuario.data('grupo-id'),
    });
  }

  // eslint-disable-next-line class-methods-use-this
  _conectarFechas() {
    const inputFechaInicio = this.element.querySelector('[name="justificacion[inicio]"]');
    const inputFechaFin = this.element.querySelector('[name="justificacion[fin]"]');

    inputFechaInicio.addEventListener('change', () => {
      // Al cambiar la de inicio siempre pone la misma fecha en la de fin
      inputFechaFin.value = inputFechaInicio.value;
      this._refrescarHorarios();
    });

    inputFechaFin.addEventListener('change', () => {
      const inicio = datepickerToDate(inputFechaInicio.value);
      const fin = datepickerToDate(inputFechaFin.value);
      if (fin.getTime() < inicio.getTime()) {
        inputFechaInicio.value = inputFechaFin.value;
      }
      this._refrescarHorarios();
    });
  }
}
